"use strict";

(function () {
  const setMegaMenu = function () {
    const customSiteHeader = document.querySelector(
      "header.custom-site-header"
    );
    if (!customSiteHeader) return;
    const nav = customSiteHeader.querySelector(".custom-site-header__nav");
    const dropdowns = customSiteHeader.querySelectorAll(
      ".custom-site-header__dropdown"
    );
    const closeAllDropdowns = function () {
      dropdowns.forEach((dropdown) => {
        dropdown.classList.remove("active");
        dropdown.classList.add("hidden");
      });
    };

    const navList = customSiteHeader.querySelectorAll(
      "ul.custom-site-header__nav-list > li[data-handle]"
    );
    if (!navList) return;

    navList.forEach((navItem) => {
      const { handle } = navItem.dataset;
      const dropdown = document.querySelector(
        `.custom-site-header__dropdown[data-handle="${handle}"]`
      );
      navItem.addEventListener("mouseenter", () => {
        closeAllDropdowns();
        if (!dropdown) return;
        dropdown.classList.add("active");
        dropdown.classList.remove("hidden");
      });
    });

    nav.addEventListener("mouseleave", closeAllDropdowns);
  };

  setMegaMenu();

  // all anchores pointing to YouTube will load a modal with the video
  document.addEventListener("DOMContentLoaded", function () {
    const modalContainer = document.createElement("div");
    modalContainer.id = "youtubeModal";
    modalContainer.classList.add("custom-modal");
    modalContainer.innerHTML = `
    <div class="custom-modal-content">
      <span class="close">&times;</span>
      <div id="videoContainer"></div>
    </div>
    `;
    document.body.appendChild(modalContainer);

    // Function to get the YouTube video ID from a YouTube URL
    function getYouTubeID(url) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length == 11 ? match[2] : null;
    }

    // Get all anchor tags in the document
    const anchorTags = document.querySelectorAll("a");

    // Iterate over each anchor tag
    anchorTags.forEach((anchor) => {
      const href = anchor.getAttribute("href");
      const youtubeID = getYouTubeID(href);

      if (youtubeID) {
        // Prevent the default behavior for YouTube links
        anchor.addEventListener("click", function (event) {
          event.preventDefault(); // Stop navigation
          openModal(youtubeID); // Open the modal with the YouTube video
        });
      }
    });

    // Modal related code
    const closeButton = modalContainer.querySelector(".close");
    const videoContainer = modalContainer.querySelector("#videoContainer");

    // Open the modal and load the YouTube video
    function openModal(videoID) {
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.youtube.com/embed/${videoID}?autoplay=1`;
      iframe.allow = "autoplay; encrypted-media";

      videoContainer.innerHTML = ""; // Clear previous video if any
      videoContainer.appendChild(iframe);

      modalContainer.style.display = "block"; // Show the modal
    }

    // Close the modal when the close button is clicked
    closeButton.addEventListener("click", function () {
      modalContainer.style.display = "none";
      videoContainer.innerHTML = ""; // Remove the iframe
    });

    // Close the modal if clicked outside the modal content
    window.addEventListener("click", function (event) {
      if (event.target == modalContainer) {
        modalContainer.style.display = "none";
        videoContainer.innerHTML = ""; // Remove the iframe
      }
    });
  });
})();
document.addEventListener('DOMContentLoaded', function() {
  var videos = document.querySelectorAll('.slideshow-slide video');
  videos.forEach(function(video) {
    video.preload = 'auto';
    video.load();
  });
});
